import { ReactNode } from 'react';

import { PlanBreakdownColumn, PlanBreakdownText } from './planDetailsRow.styles';

type Props = {
  main: ReactNode;
  side: ReactNode;
  semiBold?: boolean;
};

export const PlanDetailsRow = ({ main, side, semiBold }: Props) => (
  <PlanBreakdownColumn>
    <PlanBreakdownText semiBold={semiBold}>{main}</PlanBreakdownText>

    <PlanBreakdownText semiBold={semiBold}>{side}</PlanBreakdownText>
  </PlanBreakdownColumn>
);
